import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMediaQuery } from 'react-responsive';
import { MEDIA_XL, MEDIA_LG, MEDIA_MD } from '../../../define/media_queries';
const MediaQueryForConsultantSearchHoc = (ChildComponent) => {
    const MediaQueryForConsultantSearchHocInner = (props) => {
        const isXl = useMediaQuery(MEDIA_XL);
        const isLg = useMediaQuery(MEDIA_LG);
        const isMd = useMediaQuery(MEDIA_MD);
        return _jsx(ChildComponent, Object.assign({}, props, { isLg: isLg, isMd: isMd, isXl: isXl }));
    };
    MediaQueryForConsultantSearchHocInner.propTypes = {};
    return MediaQueryForConsultantSearchHocInner;
};
export default MediaQueryForConsultantSearchHoc;
